import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/services/Api'
import AdditionsService from '@/services/AdditionsService'

// import { 
// 	loginRoute, 
// 	verifyRoute, 
// } from './api/api.js'

import router from './router/index.js';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		status: localStorage.getItem('authenticated') || '',
		token: localStorage.getItem('token') || '',
		user: localStorage.getItem('user') || '',
		userObject: JSON.parse(localStorage.getItem('userObject') || '{}'),
		mail: localStorage.getItem('mail') || 'support@nejpripojeni.cz',
		powers: localStorage.getItem('powers') || [],
	},
	getters: {
		status: state => {
			return state.status
		},

		getUser: state => {
			return state.user
		},

		getUserObject: state => {
			return state.userObject
		},
		
		getPowers: state => {
			return state.powers
		},

		getAuthenticated: state => {
			// console.log('ej', localStorage.getItem('authenticated'))
			return localStorage.getItem('authenticated')
		}
	},
	mutations: {
		AUTH_SUCCESS (state, obj) {
			state.status = 'true'
			state.token = obj.token
			state.user = obj.user
			state.userObject = obj.userObject
		},

		AUTH_ERROR (state) {
			state.status = 'error'
		},

		AUTH_LOGOUT (state) {
			state.status = ''
			state.token = ''
			state.user = ''
		},

		CHANGE_EMAIL_PASSED(state, newEmail) {
			state.userObject.email = newEmail
			localStorage.setItem('userObject', JSON.stringify(state.userObject))
		},

		CHANGE_CONTACT_PASSED(state, newContact) {
			state.userObject.contact_number = newContact
			localStorage.setItem('userObject', JSON.stringify(state.userObject))
		},

		
	},
	actions: {
		returnUser () {
			return 'b'
		},

		async getMail (state, user) {
			const mail = await AdditionsService.getMailRoute(user)
			// console.log(mail.data)
			localStorage.setItem('mail', mail.data)
		},

		async loginAction (state, obj2) {
			const logged = await AdditionsService.loginRoute(obj2.userName, obj2.password);
			if (! logged) {
				localStorage.removeItem('token')
				localStorage.removeItem('user')
				localStorage.removeItem('userObject')
				localStorage.setItem('authenticated', false)
                localStorage.removeItem('powers')
				this.commit('AUTH_ERROR')
				return false
			}

			if (logged.passed) {
				localStorage.setItem('token', logged.token)
				localStorage.setItem('authenticated', true)
				localStorage.setItem('user', obj2.userName)
                localStorage.setItem('userObject', JSON.stringify(logged.user))
				localStorage.setItem('powers', logged.powers)
                
				this.commit('AUTH_SUCCESS', { token: logged.token, user: obj2.userName, userObject: logged.user })
				// router.push('/profile')
				return logged.powers
			}
		},

		async verifyAction (store) {
			const verified = await AdditionsService.verifyRoute(store.state.token);

			if (! verified) {
				localStorage.removeItem('token')
				localStorage.setItem('authenticated', false)

				this.commit('AUTH_ERROR')
			}
		},

		async refreshUserAction (store, obj2) {
			// const logged = await AdditionsService.loginRoute(obj2.userName, obj2.password);
		},

		async logoutAction () {
			localStorage.removeItem('token')
			localStorage.removeItem('user')
            localStorage.removeItem('userObject')
            localStorage.removeItem('powers')
            localStorage.removeItem('mail')
			localStorage.setItem('authenticated', false)
			this.commit('AUTH_LOGOUT')
		},		
	}
})



// WEBPACK FOOTER //
// ./src/store.js